module.exports = __webpack_public_path__ + "img/loading.28a21ca1.gif";